import { useHistory } from "react-router";

function EventWeek({ event }) {
  const history = useHistory();

  let cancelledEvent = event && event.status == "canceled" ? true : false;

  return (
    <div
      onClick={() => history.push("/my-appointments/" + event.id)}
      className="border-l-4 border-indigo-600 border-l-4 p-1 overflow-auto shadow-2xl"
    >
      <div
        style={{ color: "grey" }}
        className="flex mr-1 rounded-full pr-1"
      >
        <img
          src={ event.profile_pic ? event.profile_pic : "/avator.png"}
          height={20}
          width={20}
          alt="avator"
          className="rounded-full mr-2"
        />
        <div>
        <div
          className={`text-sm font-bold ${
            cancelledEvent ? "line-through text-red-500" : "text-secondary"
          }`}
        >
          {event.name}
        </div>
        <div
          className={`text-xs font-bold opacity-50  ${
            cancelledEvent ? "line-through text-red-500" : "text-secondary"
          }`}
        >
          {new Date(event.start).toLocaleDateString("en-us", {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </div>
        </div>
      </div>
      <div>
        
        
        <div
          className={`text-xs font-bold opacity-50 mt-1 mb-1 ${
            cancelledEvent ? "line-through text-red-500" : "text-secondary"
          }`}
        >
          {event.clinic}
        </div>
        <div className="">
          <span className="text-xs text-secondary font-bold opacity-50 mt-1.5 mb-2 p-1 bg-gray-200 rounded">
            Requested
          </span>
        </div>
      </div>
    </div>
  );
}

export default EventWeek;
